<template>
    <Card class="layout-card">
        <div style="margin-bottom: 10px;">
            <div class="search-form">
                <Select v-model="metrics" multiple placeholder="请选择指标" :max-tag-count="1"
                    @on-change="changeMetric" label-in-value filterable style="width: 17%;">
                    <template #prefix>
                        <a style="font-size: 12px;padding: 0 5px;white-space: nowrap;" @click="(e) => {
                            e.preventDefault()
                            e.stopPropagation();
                            if (metric.length === homeData.length) {
                                metrics = []
                                changeMetric([])
                            }
                            else {
                                const data = homeData.map(i => i.value)
                                metrics = data
                                changeMetric(homeData)
                            }

                        }">{{ metric.length === homeData.length ? '清空' : '全选' }}</a>
                    </template>
                    <Option v-for="(i, index) in homeData" :key="index" :value="i.value">{{ i.label }}</Option>
                </Select>
                <DatePicker :editable="false" format="yyyy-MM-dd" type="daterange" style="width: 15%;" placeholder="请选择日期"
                    :value="listDate" @on-change="getListDate" :clearable="false"></DatePicker>

                <Select v-model="searchForm.timeZone" placeholder="请选择时区" style="width: 12%;">
                    <!-- <Option :value="8">东八区</Option>/ -->
                    <Option :value="-8">西八区</Option>
                </Select>
                <Select v-model="person" placeholder="请选择优化师" filterable :max-tag-count="1" multiple
                    style="width: 230px" :disabled="!searchOptions.person.length"
                    @on-change="searchForm.personIds = $event">
                    <template #prefix>
                        <a v-show="searchOptions.person.length"
                            style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                if (person.length === searchOptions.person.length) {
                                    searchForm.personIds = []
                                    changePerson([])
                                }
                                else {
                                    const data = [...searchOptions.person.map(i=>i.id)]
                                    $set(searchForm, 'personIds', data)
                                    changePerson(data)
                                }

                            }">{{ person.length !== searchOptions.person.length ? '全选' : '清空' }}</a>
                    </template>
                    <Option v-for="(i, index) in searchOptions.person" :key="index" :value="i.id">{{ i.dictName }}</Option>
                </Select>
                <Select v-model="campaign" placeholder="请选择广告系列" filterable :max-tag-count="1" multiple
                    style="width: 28%;" :disabled="!searchOptions.campaign.length"
                    @on-change="searchForm.advertiseSeriesIds = $event">
                    <template #prefix>
                        <a v-show="searchOptions.campaign.length"
                            style="font-size: 12px;padding: 0 5px;white-space:nowrap" @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                if (campaign.length === searchOptions.campaign.length) {
                                    searchForm.advertiseSeriesIds = []
                                    changeCampaign([])
                                }
                                else {
                                    const data = [...searchOptions.campaign.map(i=>i.campaignId)]
                                    $set(searchForm, 'advertiseSeriesIds', data)
                                    changeCampaign(data)
                                }

                            }">{{ campaign.length !== searchOptions.campaign.length ? '全选' : '清空' }}</a>
                    </template>
                    <Option v-for="(i, index) in searchOptions.campaign" :key="index" :value="i.campaignId">{{ i.campaignName }}</Option>
                </Select>
                <Input style="width: 200px;" placeholder="广告系列ID" v-model="campaignId" />
                <Select placeholder="渠道" clearable v-model="searchForm.channel" style="width: 200px">
                    <Option :value="0">facebook</Option>
                    <Option :value="1">tiktok</Option>
                    <Option :value="2">其他</Option>
                </Select>
                <Select placeholder="投放类型" clearable v-model="searchForm.advertiseType" style="width: 200px" >
                    <Option :value="0">W2A</Option>
                    <Option :value="1">直投</Option>
                </Select>
                <Select v-model="searchForm.langId" placeholder="请选择语言" style="width: 200px" clearable>
                      <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                </Select>
                <Button type="primary" @click="getData()">查询</Button>
                <Button style="width: auto;" @click="handleReset()">重置</Button>
                <Button style="width: auto;" type="warning" @click="handleExport()" :loading="exportLoading">导出</Button>
            </div>
        </div>
        <div>
            <Table border :data="tableData" :columns="column" v-if="columns.length > 1" :loading="showTable" show-summary ref="tableRef"
                :summary-method="handleSummary" @on-sort-change="test">
                <Pages slot="footer" :page="page" :func="getData" :pArr="[31,50]"></Pages>
            </Table>
            <div v-else style="text-align: center;font-size: 18px;padding: 20px 0">请选择查询项</div>
        </div>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getLangList } from '@/api/lang'
import { utils, writeFile } from 'xlsx'
import { getCampainInit, getPersonInit, gePitcherData, exportPitcherData } from '@/api/data'
import dayjs from 'dayjs'
import home, { homeData } from '.'
import { cloneDeep } from 'lodash'
export default {
    name: 'pitcher',
    components: {
        Pages
    },
    data() {
        return {
            homeData,
            editVisible: false,
            sum: [],
            form: {},
            exportLoading:false,
            searchForm: {
                personIds: [],
                advertiseSeriesIds: [],
                timeZone: -8
            },
            listDate: [],
            submitLoading: false,
            showTable: false,
            page: {
                current: 1,
                size: 31,
                total: 0
            },
            langList: [],
            metric: [],
            metrics: [],
            tableData: [],
            column: [],
            realData: [],
            campaignId: '',
            campaign: [],
            person: [],
            orders: {
                key: '',
                order: ''
            },
            searchOptions: {
                campaign: [],
                person: []
            },
            sortKey: ''
        }
    },
    computed: {
        buttonMenu() {
            const li = this.$store.getters.getMenuRules('data')
            const obj = {}
            li.forEach(i => {
                obj[i.menuPath] = true
            })
            return obj
        },
        columns() {
            const li = []
            const res = this.metric.map(i => {
                return {
                    title: i.label,
                    key: i.value.split(',')[1],
                    width: i.width ? i.width : (i.label.length > 5 ? 140 : 100),
                    needCalc: i.needCalc,
                    tooltip: !!i.tooltip,
                    tooltipMaxWidth: i.tooltipMaxWidth,
                    resizable: i.resizable,
                    calc: i.calc,
                    sortable: !i.sortable?false:'custom',
                    render: i.render
                }

            })
            this.searchForm.sortKeyId = null
            this.searchForm.sortDesc = null
            // console.log(res);
            // if(this.searchForm.country){
            //   li.push({
            //     title: '国家/地区',
            //     key: 'countryCode	',
            //   width: 100
            // })
            // }
            // if(this.searchForm.os){
            //   li.push({
            //     title: 'OS',
            //   width: 100,
            //     key: 'os'
            //   })
            // }
            
            return [{
                title: '序号',
                key: 'index',
                render:(h,params)=>{
                    
                    return <div>
                            {(this.page.current-1)*this.page.size+params.row._index+1}
                        </div>
                },
              width: 100
            }, ...li
                , ...res].map(i=>({
                    ...i,
                    resizable: true,
                }))
        }
    },
    methods: {
        test({ column, key, order }) {
            this.sortKey = key

            homeData.forEach(el => {
                const [k, v] = el.value.split(',')
                if(v == this.sortKey){
                    
                    this.searchForm.sortKeyId = this.sortKey.includes('person')?2:k
                }
            });
            if(order == 'asc'){
                this.searchForm.sortDesc = false
            }else{
                this.searchForm.sortDesc = true
            }
            if(order == 'normal'){
                this.searchForm.sortKeyId = null
                this.searchForm.sortDesc = null
                
            }
            this.getData()
        },
        handleExport() {
            let advertiseSeriesIds = []
            if(this.campaignId){
                advertiseSeriesIds = [this.campaignId]
            }else{
                advertiseSeriesIds = this.searchForm.advertiseSeriesIds && this.searchForm.advertiseSeriesIds.length ? [...this.searchForm.advertiseSeriesIds].map(i => i.split(',')[0]) : []
            }
            this.exportLoading = true
            exportPitcherData({
                ...this.searchForm,
                distinguishDate: this.metrics.indexOf('1,statDate')>-1,
                personIds: this.searchForm.personIds && this.searchForm.personIds.length ? [...this.searchForm.personIds] : [],
                advertiseSeriesIds
            }).then(r=>{
                this.exportLoading = false
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = r.data.fileUrl
                // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                link.setAttribute('download', r.data.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },
        handleSummary({ columns, data }) {

            const res = {}
            const sums = {}
            columns.forEach((column, index) => {
                const key = column.key
                if (!index) {
                    sums[key] = {
                        key,
                        value: '合计'
                    }
                    return
                }
                sums[key] = {
                    key,
                    value: column.needCalc?((this.sum[key]*100).toFixed(2)+'%'||'-'):this.sum[key]
                }
            })

            return sums

        },
        changeMetric(e) {
            const values = e.map(i => i.value)
            localStorage.setItem('users', JSON.stringify(values))
            this.metric = homeData.filter(i => values.indexOf(i.value) > -1)
            this.searchForm.fieldIds = values.map((i=>i.split(',')[0]))
        },
        changeCampaign(e) {
            this.campaign = e
        },
        changePerson(e) {
            this.person = e
        },
        getListDate(data) {
            this.listDate = data
            this.searchForm.startDate = data[0]
            this.searchForm.endDate = data[1]
        },
        handleGetLang() {
            getLangList({ current: -1, size: -1 }).then(r => {
                this.langList = r.data.records
            })
        },
        getData(current) {
            this.showTable = true
            this.column = this.columns
            if(!current){
                this.page.current = 1
            }else{
                this.page.current = current
            }
            let advertiseSeriesIds = []
            if(this.campaignId){
                advertiseSeriesIds = [this.campaignId]
            }else{
                advertiseSeriesIds = this.searchForm.advertiseSeriesIds && this.searchForm.advertiseSeriesIds.length ? [...this.searchForm.advertiseSeriesIds].map(i => i.split(',')[0]) : []
            }
            gePitcherData({
                ...this.searchForm,
                ...this.page,
                distinguishDate: this.metrics.indexOf('1,statDate')>-1,
                personIds: this.searchForm.personIds && this.searchForm.personIds.length ? [...this.searchForm.personIds] : [],
                advertiseSeriesIds
            }).then(({ data }) => {
                this.tableData = data.pageData.records
                this.page.total = data.pageData.total
                this.sum = data.sum
                if (process.env.NODE_ENV === 'development') {
                    //     this.realData = [
                    //     {
                    //     "createTime": "2025-05-23",
                    //     "countryCode": null,
                    //     "channel": null,
                    //     "os": null,
                    //     "campaign": null,
                    //     "cost": 7226.63,
                    //     "activation": 1556,
                    //     "registrationCount": null,
                    //     "activationCost": 4.64,
                    //     "registrationCost": null,
                    //     "firstRechargeCount": 175,
                    //     "firstCostCount": 41.3,
                    //     "firstRechargeCost": 4088.67,
                    //     "firstPayRate": 0.11,
                    //     "firstARPU": 23.36,
                    //     "firstROI": 0.57,
                    //     "thirdROI": 0.57,
                    //     "eighthROI": 0.57,
                    //     "fifthROI": 0.57,
                    //     "totalROI": 0.57,
                    //     "totalRecharge": 7276.73,
                    //     "thirdRecharge": 4088.67,
                    //     "eighthRecharge": 4088.67,
                    //     "fifthRecharge": 4088.67,
                    //     "thirtyRecharge": 4088.67,
                    //     "sixtyRecharge": 4088.67,
                    //     "allRecharge": 4088.67,
                    //     "threeTimesGrowth": 1,
                    //     "eightTimesGrowth": 1,
                    //     "fourthTimesGrowth": 1,
                    //     "thirtyTimesGrowth": 1,
                    //     "sixtyTimesGrowth": 1,
                    //     "gross": null,
                    //     "dau": null,
                    //     "day1Retention": null,
                    //     "day3Retention": null
                    // }
                    //     ]
                    //     this.realData = Array.from({length:33},()=>{
                    //       return {...this.realData[0]}
                    //     })
                    //     this.$set(this.realData[9],'cost',123)
                    //     this.$set(this.realData[32],'cost',122223)
                    //     this.page.total = this.realData.length
                }
                // this.getTable()
                this.showTable = false
            })
        },
        // getTable(page) {
        //     if (page) this.page.current = page
        //     else this.page.current = 1

        //     const tb = cloneDeep(this.realData)
        //     if (this.orders.order && this.orders.order != 'normal') {
        //         if (this.orders.order == 'asc') {
        //             tb.sort((a, b) => {
        //                 return a[this.orders.key] - b[this.orders.key]
        //             })
        //         } else {
        //             tb.sort((a, b) => {
        //                 return b[this.orders.key] - a[this.orders.key]
        //             })
        //         }
        //     }
        //     this.tableData = tb.slice((this.page.current - 1) * this.page.size, this.page.current * this.page.size)


        // },
        handleGetDataInit() {
            getCampainInit({current:1,size: 1000000}).then(r => {
                this.searchOptions.campaign = r.data.records

            })
            getPersonInit().then(r=>{
                this.searchOptions.person = r.data.records
            })
        },
        handleReset() {
            
            this.searchForm = {
                channel: '',
                sortKeyId: this.searchForm.sortKeyId,
                sortDesc:this.searchForm.sortDesc,
                adsCampaign: [],
                personIds: [],
                timeZone: -8
            }
            this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
            // this.$refs.tableRef.handleSort(this.column.findIndex(i=>i.key==this.sortKey),'normal')
            this.channels = []
            this.person = []
            this.campaign = []
            this.changeMetric(homeData.filter(i => !i.disabled))
            this.sortKey = ''
            this.handleGetDataInit()        
        }
    },
    mounted() {
        this.handleGetLang()
        // this.getData()
        const metric = localStorage.getItem('users')
        if (!metric) {
            this.metrics = homeData.filter(i => !i.disabled).map(i => i.value)
            this.changeMetric(homeData.filter(i => !i.disabled))
        } else {
            this.metrics = JSON.parse(metric)
            this.metric = homeData.filter(i => JSON.parse(metric).indexOf(i.value) > -1)
            this.searchForm.fieldIds = this.metrics.map((i=>i.split(',')[0]))

        }
        this.handleGetDataInit()
        this.column = this.columns
        this.getListDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])
    },
    activated(){
        this.handleGetDataInit()
    }
}
</script>

<style scoped lang="less">
.search-form {
    display: flex;
    flex-wrap: wrap;

    &>* {
        margin: 0 5px 10px;

    }
}

.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}

/deep/.ivu-table td,
.ivu-table th {
    height: 20px;
}

/deep/.ivu-table {
    .ivu-table-tbody {
        .ivu-table-row:last-child {
            height: 30px;

            td {
                vertical-align: top;
                height: 30px;
            }
        }

    }
}
</style>